// departmen cookie is set on
// -- 1. every page load
// -- 2. department change

const departmentCookieName = "_ocmDepartment";

export function setDepartmentCookie(departmentkey) {
    if (!departmentkey || typeof departmentkey !== "string") return;
    const department = mapDepartment(departmentkey);

    if (department) {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1); // expires in 1 year
        document.cookie = `${departmentCookieName}=${department}; expires=${date.toUTCString()}; path=/`;
    }
}

export function getDepartmentCookie() {
    return getCookie(departmentCookieName)
}

// Helper Funktions

// hybris department key to english department name
const DEPARTMENTS_MAP = {
    "damen": "female",
    "herren": "male",
    "kinder": "kids"
}

function mapDepartment (departmentkey) {
    // hybris department key to english department name
    return DEPARTMENTS_MAP[departmentkey?.toLowerCase()] || "";
}

function getCookie (name) {
    const regex = new RegExp('(?:^|; )' + name + '=([^;]*)');
    const match = document.cookie.match(regex);
    return match ? decodeURIComponent(match[1]) : null;
}